import { BaseComponent, Component, Prop, Ref, SimpleEvent, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";
import { log } from "console";

/**
 * Product Details
 */
@Component
export class ProductDetails extends ThemeComponent {
    @Ref vatModalBtn!: HTMLElement[];
    @Ref vatModal!: HTMLElement[];
    @Ref vatModalClose!: HTMLElement[];


    init() {
        this.$listen(this.vatModalBtn[0], 'click', () => {
            this.vatModal[0].classList.add('active');
        });

        this.$listen(this.vatModalClose[0], 'click', () => {
            this.vatModal[0].classList.remove('active');
        });

        this.$listen(this.vatModal[0], 'click', (e) => {
            const targetChildren = e.target as HTMLTextAreaElement;

            if(targetChildren.children[0].className === 'modal__inner') {
                this.vatModal[0].classList.remove('active');
            }
        });

    }
}
